import { useState } from 'react';
import { useFetchSubsidyCalculatorData } from './useFetchSubsidyCalculatorData';
import { SelectOption } from 'global';

interface Params {
  accountId: string;
}

export function useSubsidyCalculator({ accountId }: Params) {
  const { selectedProgramId, programOptions, isOptionsLoading, isProgramLoading, financeProgram, selectProgram } =
    useFetchSubsidyCalculatorData({ accountId });

  const [selectedTerm, setSelectedTerm] = useState<string>('');

  const subsidies: { term: string; subsidyPercentage: number; dnetPercentage: number }[] =
    financeProgram?.paymentOptionsConfiguration?.subsidies ?? [];

  const termOptions: SelectOption[] = subsidies.map(s => ({
    label: `${s.term} months`,
    value: s.term,
  }));

  const selectedSubsidy = subsidies.find(s => s.term === selectedTerm);

  const isSubsidyEligible =
    !!financeProgram && (!!financeProgram.paymentOptionsConfiguration?.isSubsidized || subsidies.length > 0);

  const subsidyPercent = selectedSubsidy?.subsidyPercentage ?? subsidies[0]?.subsidyPercentage ?? 0;
  const dnetPercent = selectedSubsidy?.dnetPercentage ?? subsidies[0]?.dnetPercentage ?? 0;

  const handleProgramChange = (programId: string) => {
    setSelectedTerm('');
    selectProgram(programId);
  };

  return {
    selectedProgramId,
    programOptions,
    isOptionsLoading,
    isProgramLoading,
    program: financeProgram,
    isSubsidyEligible,
    subsidyPercent,
    dnetPercent,
    termOptions,
    selectedTerm,
    handleTermChange: setSelectedTerm,
    handleProgramChange,
  };
}
